import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { RestBuilder } from '../helpers/rest.builder';
import { ITenant, IUpdateTenantAcademyRequest } from '../../../../shared/interfaces/tenant.interface';
import { IAcademySsoLink, ISkilljarSignupField } from '../../../../shared/interfaces/academy-integration.interface';

@Injectable({ providedIn: 'root' })
export class AcademyApi {
  private restBuilder: RestBuilder;

  constructor(private httpClient: HttpClient) {
    this.restBuilder = new RestBuilder();
  }

  // GET /tenants/academy/sso-link
  public generateAcademySSOLink(): Observable<IAcademySsoLink> {
    const url: string = this.restBuilder.create().tenant().academy().ssoLink().getApiUrl();
    return this.httpClient.get<IAcademySsoLink>(url);
  }

  // GET /tenants/academy/available
  public isAcademyAvailable(): Observable<boolean> {
    const url: string = this.restBuilder.create().tenant().academy().available().getApiUrl();
    return this.httpClient.get<boolean>(url);
  }

  // PUT /tenants/academy
  public updateAcademy(tenantId: string): Observable<ITenant> {
    const url: string = this.restBuilder.create().tenant().academy().getApiUrl();
    return this.httpClient.put<ITenant>(url, { tenantId } as IUpdateTenantAcademyRequest);
  }

  // GET /tenants/academy/available-groups
  public getAvailableSignupFields(): Observable<ISkilljarSignupField> {
    const url: string = this.restBuilder.create().tenant().academy().availableSignupFields().getApiUrl();
    return this.httpClient.get<ISkilljarSignupField>(url);
  }
}
